import React from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { Nav, Container } from "react-bootstrap";
import { MdLogout, MdHome } from "react-icons/md";
import { history } from "../../../store/configure/configureStore";
//
import {
  USER_MANAGEMENT,
  ADMIN_PANEL_USERS,
  MOBILE_PANEL_USERS,
  USER_DETAILS,
  MEDIA_MANAGEMENT,
  CONTENT_MANAGEMENT,
  YOUTUBE,
  BANNERS,
  ADD_BANNER,
  VIEW_BANNER,
  EDIT_BANNER,
  NOTIFICATIONS,
  ADD_NOTIFICATIONS,
  EDIT_NOTIFICATIONS,
  SEND_NOTIFICATIONS,
  INSTAGRAM,
  CONTENT_DETAIL,
  SUBSCRIPTION,
  TRANSACTION_HISTORY,
  ACTIVITY_LOGS,
} from "../../../constants/constants";

//
import { showSidebar } from "../../../store/sidebar/sidebarActions";
//
import "./HeaderStyles.scss";

const Header = ({ showSidebar, label, logout }) => {
  const { id } = useParams();
  // console.log("header id", id);
  var showMenu = true;

  const breadCrumbs = [
    {
      path: "/user-management/admin-panel-users",
      breadCrumb: `/ ${USER_MANAGEMENT} / ${ADMIN_PANEL_USERS}`,
    },
    {
      path: "/user-management/mobile-app-users",
      breadCrumb: `/ ${USER_MANAGEMENT} / ${MOBILE_PANEL_USERS}`,
    },
    {
      path: `/mobile-app-users/user-details/${id}`,
      breadCrumb: `/ ${USER_MANAGEMENT} / ${MOBILE_PANEL_USERS} / ${USER_DETAILS}`,
    },
    {
      path: "/media/youtube-management",
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${YOUTUBE}`,
    },
    {
      path: `/media/content-detail/youtube/${id}`,
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${YOUTUBE} / ${CONTENT_DETAIL}`,
    },
    {
      path: "/media/content-detail/instagram",
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${INSTAGRAM} / ${CONTENT_DETAIL}`,
    },
    {
      path: "/media/content-detail/instagram",
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${INSTAGRAM} / ${CONTENT_DETAIL}`,
    },
    {
      path: "/media/banner-management",
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${BANNERS}`,
    },
    {
      path: "/media/add-banner",
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${BANNERS} / ${ADD_BANNER}`,
    },
    {
      path: `/media/view-banner/${id}`,
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${BANNERS} / ${VIEW_BANNER}`,
    },
    {
      path: `/media/edit-banner/${id}`,
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${BANNERS} / ${EDIT_BANNER}`,
    },
    {
      path: `/media/notification-management`,
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${NOTIFICATIONS} `,
    },
    {
      path: `/media/notification-management/add-notification`,
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${NOTIFICATIONS} / ${ADD_NOTIFICATIONS}`,
    },
    {
      path: `/media/notification-management/edit-notification/${id}`,
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${NOTIFICATIONS} / ${EDIT_NOTIFICATIONS} `,
    },
    {
      path: `/media/notification-management/send-notifications/${id}`,
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${NOTIFICATIONS} / ${SEND_NOTIFICATIONS} `,
    },
    {
      path: `/media/notification-management/activity-log/${id}`,
      breadCrumb: `/ ${CONTENT_MANAGEMENT} / ${NOTIFICATIONS} / ${ACTIVITY_LOGS} `,
    },
    {
      path: `/subscription/transaction-history`,
      breadCrumb: `/ ${SUBSCRIPTION} / ${TRANSACTION_HISTORY}`,
    },
  ];

  const renderPath = () => {
    const path = [];
    breadCrumbs.forEach((item) => {
      if (history.location.pathname === item.path) {
        path.push(item.breadCrumb);
      }
    });
    return path;
  };

  // console.log(window.location);

  return (
    <div className="header fixed-top">
      <div className="path-content-wrapper">
        {/* <MdHome size={20} /> Home {renderPath()} */}
      </div>
      <div className="logout-wrapper" onClick={logout}>
        <MdLogout /> Logout
      </div>
    </div>
  );
};

Header.propTypes = {
  label: PropTypes.string.isRequired,
  Icon: PropTypes.func.isRequired,
  btnData: PropTypes.array,
};

Header.defaultProps = {
  btnData: [],
};

export default Header;
